import {
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@mui/material';
import React from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { WsButton } from 'wisestep-base';

interface AddEditInvoiceExtraProps {
  onSave: (body: any, status: boolean) => void;
  onCancel: () => void;
  associateJson: any;
}

const AddEditAssociate: React.FC<AddEditInvoiceExtraProps> = ({
  onSave,
  onCancel,
  associateJson,
}) => {
  const form = useForm();
  const onSubmit = async (data) => {
    const { type, ...restData } = data;
    const stage = associateJson['stage' + type.replace('option', '')];
    const status = associateJson['status' + type.replace('option', '')];

    onSave({ type, stage, status, ...restData }, true);
  };
  const options = Object.keys(associateJson).filter(
    (key) =>
      key.startsWith('option') &&
      typeof associateJson[key] === 'string' &&
      associateJson[key].trim() !== ''
  );

  return (
    <>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Grid item xs={6} marginTop={3} marginLeft={3}>
            <DialogTitle>{associateJson.questionDescription} ?</DialogTitle>
          </Grid>
          <DialogContent>
            <Grid item xs={6} marginLeft={3}>
              <FormControl component="fieldset">
                <Controller
                  name="type"
                  control={form.control}
                  defaultValue=""
                  render={({ field }) => (
                    <RadioGroup {...field}>
                      {options.map((option) => (
                        <FormControlLabel
                          key={option}
                          value={option}
                          control={<Radio />}
                          label={associateJson[option]}
                        />
                      ))}
                    </RadioGroup>
                  )}
                />
              </FormControl>
            </Grid>
          </DialogContent>
          <DialogActions>
            <WsButton variant="outlined" onClick={onCancel}>
              Cancel
            </WsButton>
            <WsButton type="submit">Save</WsButton>
          </DialogActions>
        </form>
      </FormProvider>
    </>
  );
};

export default AddEditAssociate;
